var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._b(
      {
        attrs: { label: "Buscar...", "single-line": "", "hide-details": "" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      },
      "v-text-field",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }